import React from 'react';
import Header from '../components/Header';
import CaseStudiesHero2 from '../components/CaseStudyTwo/CaseStudiesHero2';
import CaseStudiesBeginning2 from '../components/CaseStudyTwo/CaseStudiesBeginning2';
import CaseStudiesTesting2 from '../components/CaseStudyTwo/CaseStudiesTesting2';
import CaseStudiesResults2 from '../components/CaseStudyTwo/CaseStudiesResults2';
import CaseStudiesCallout2 from '../components/CaseStudyTwo/CaseStudiesCallout2';
import '../styles/custom.css';

const CaseStudiesPageTwo = () => {
  return (
    
    <div className="page-wrapper">
      <Header />
      <CaseStudiesHero2 />
      <CaseStudiesBeginning2 />
      <CaseStudiesTesting2 />
      <CaseStudiesResults2 />
      <CaseStudiesCallout2 />
    </div>
  );
}

export default CaseStudiesPageTwo;